import { Fragment } from 'react';

export function InformationAboutYou() {
  return (
    <Fragment>
      We process information about you in accordance with our <a href="/privacy">privacy and cookies policy</a>. By using our site, you consent to such processing and you warrant that all data provided by you is accurate.
    </Fragment>
  );
}


export default InformationAboutYou;
